import { useCallback } from "react";

const UsePrintSlip = (onOverrideUpdate) => {
  const printSlip = useCallback(
    (selectedBooks, isOverrideMode, useManualTotal, getOverriddenAmounts) => {
      if (selectedBooks.size === 0) {
        alert("Please select at least one book to generate the overdue slip.");
        return;
      }

      // Pass override data to parent before printing (without closing the modal)
      if (isOverrideMode || useManualTotal) {
        const overrideData = {
          ...getOverriddenAmounts(),
          overrideAmounts: getOverriddenAmounts().overrideAmounts,
          isOverrideMode: isOverrideMode,
          manualTotalOverride: getOverriddenAmounts().manualTotalOverride,
          useManualTotal: useManualTotal,
        };

        // Update parent with override data without closing modal
        if (onOverrideUpdate) {
          onOverrideUpdate(overrideData);
        }
      }

      // Get the content to print
      const printContent = document.getElementById("overdue-slip-content");

      // Get all existing stylesheets from the current page
      const stylesheets = Array.from(document.styleSheets);
      let allStyles = "";

      // Extract CSS rules from all stylesheets
      stylesheets.forEach((stylesheet) => {
        try {
          if (stylesheet.cssRules) {
            Array.from(stylesheet.cssRules).forEach((rule) => {
              allStyles += rule.cssText + "\n";
            });
          }
        } catch (e) {
          // Some stylesheets might not be accessible due to CORS
          console.warn("Could not access stylesheet:", e);
        }
      });

      // Also get inline styles from style tags
      const styleTags = document.querySelectorAll("style");
      styleTags.forEach((styleTag) => {
        allStyles += styleTag.textContent + "\n";
      });

      // Create a new tab for printing
      const printTab = window.open("", "_blank");

      printTab.document.write(`
        <html>
          <head>
            <title>Overdue Slip - Print</title>
            <style>
              /* Include all existing styles */
              ${allStyles}

              /* Additional print-specific styles */
              @media print {
                body {
                  margin: 0;
                  padding: 20px;
                }
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}

            <script>
              // Auto-print when page loads
              window.onload = function() {
                window.print();

                // Navigate back to Fine Management after printing
                window.onafterprint = function() {
                  // Small delay to ensure print dialog is closed
                  setTimeout(function() {
                    // Close the modal and navigate back
                    if (window.opener && !window.opener.closed) {
                      window.opener.focus();
                      // Trigger navigation back to Fine Management
                      window.opener.postMessage({
                        action: 'navigateToFineManagement',
                        closeModal: true
                      }, '*');
                    }
                    // Close the print tab
                    window.close();
                  }, 500);
                };

                // Also handle if user cancels print dialog
                window.onfocus = function() {
                  setTimeout(function() {
                    if (window.opener && !window.opener.closed) {
                      window.opener.focus();
                      // Also navigate back if user canceled print
                      window.opener.postMessage({
                        action: 'navigateToFineManagement',
                        closeModal: true
                      }, '*');
                    }
                    window.close();
                  }, 100);
                };
              };
            </script>
          </body>
        </html>
      `);

      printTab.document.close();
    },
    [onOverrideUpdate]
  );

  return { printSlip };
};

export default UsePrintSlip;
